import React from "react";
import styles from "./Loading.module.scss";
import { ReactComponent as Spinner } from "../../assets/images/spinner.svg";

export const Loading = ({ className }) => (
  <div
    className={`d-flex flex-row justify-content-center ${styles.Loading} ${className}`}
    data-testid="Loading"
  >
    <div className={`d-flex align-items-center justify-content-center ${styles.Circle}`}>
      <Spinner className={styles.Icon} />
    </div>
  </div>
);

export const withLoader = (WrappedComponent) => ({ isComponentLoading, ...props }) => {
  return <>{isComponentLoading ? <Loading /> : <WrappedComponent {...props} />}</>;
};

export default Loading;
